import React, { useState } from 'react'; 
import {
  Box, Typography, TextField, Switch, FormControlLabel, Button, Divider, Grid, Avatar, Tooltip
} from '@mui/material';
import { motion } from 'framer-motion';
import {
  FiUser, FiLock, FiMail, FiSettings, FiShield, FiCloud, FiUpload, FiArrowLeft
} from 'react-icons/fi';
import './AdminSettingsPage.css'; // Optional: for extra tweaks
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { InputAdornment, IconButton, useTheme, useMediaQuery } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

const AdminSettingsPage = () => {
     //  Password visibility state
  const [showPassword, setShowPassword] = useState({
    current: false,
    new: false,
    confirm: false,
  });

  const toggleVisibility = (field) => {
    setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
  };

    const navigate = useNavigate();
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <motion.div
      className="admin-settings-container"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >

        {/* ✅ Back Button */}
      <Box mb={2}>
        <IconButton
          onClick={() => navigate(-1)}
          sx={{
            borderRadius: '12px',
            p: '8px 12px',
            background: 'linear-gradient(135deg, #00bcd4, #007bff)',
            color: '#fff',
            '&:hover': {
              background: 'linear-gradient(135deg, #007bff, #00bcd4)',
              transform: 'scale(1.05)'
            }
          }}
        >
          <FiArrowLeft />
          {!isSmall && (
            <Typography variant="button" sx={{ ml: 1, fontWeight: 600 }}>
              Back
            </Typography>
          )}
        </IconButton>
      </Box>

      <Typography variant="h4" className="admin-settings-title">
        <FiSettings className="gear-icon" />
        Admin Settings
      </Typography>

      {/* Profile Settings */}
      <motion.div className="settings-section admin-settings-titles" whileHover={{ scale: 1.01 }}>
        <Typography variant="h6" className="section-heading"  sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'primary.main' }}><FiUser /> Profile Settings</Typography>
        <Divider />
        <Grid container spacing={2} mt={1}>
          <Grid item xs={12} sm={6}>
            <TextField label="Admin Name" fullWidth variant="outlined" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField label="Email" fullWidth variant="outlined" type="email" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField label="Phone Number" fullWidth variant="outlined" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={<Switch color="primary" />}
              label="Enable Two-Factor Auth"
            />
          </Grid>
          <Grid item xs={12}>
            <Button variant="contained" color="primary" startIcon={<FiUpload />}>
              Upload Profile Picture
            </Button>
          </Grid>
        </Grid>
      </motion.div>

      {/* Security Settings */}
      <motion.div className="settings-section admin-settings-titles" whileHover={{ scale: 1.01 }}>
        <Typography variant="h6" className="section-heading"  sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'primary.main' }}><FiLock /> Security Settings</Typography>
        <Divider />
        
        <Grid container spacing={2} mt={1}>
          <Grid item xs={12} sm={4}>
             <TextField
        label="Current Password"
        fullWidth
        variant="outlined"
        type={showPassword.current ? 'text' : 'password'}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={() => toggleVisibility('current')} edge="end">
                {showPassword.current ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
          </Grid>
          <Grid item xs={12} sm={4}>
             <TextField
        label="New Password"
        fullWidth
        variant="outlined"
        type={showPassword.new ? 'text' : 'password'}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={() => toggleVisibility('new')} edge="end">
                {showPassword.new ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
        label="Confirm Password"
        fullWidth
        variant="outlined"
        type={showPassword.confirm ? 'text' : 'password'}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={() => toggleVisibility('confirm')} edge="end">
                {showPassword.confirm ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
          </Grid>
        </Grid>
      </motion.div>

      {/* App Settings */}
      <motion.div className="settings-section admin-settings-titles" whileHover={{ scale: 1.01 }}>
        <Typography variant="h6" className="section-heading"  sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'primary.main' }}><FiCloud /> Application Settings</Typography>
        <Divider />
        <Grid container spacing={2} mt={1}>
          <Grid item xs={12} sm={6}>
            <TextField label="Site Name" fullWidth variant="outlined" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={<Switch color="secondary" />}
              label="Enable Maintenance Mode"
            />
          </Grid>
          <Grid item xs={12}>
            <Button variant="outlined" color="secondary" startIcon={<FiUpload />}>
              Upload Logo
            </Button>
          </Grid>
        </Grid>
      </motion.div>

      {/* Notification Settings */}
      {/* <motion.div className="settings-section" whileHover={{ scale: 1.01 }}>
        <Typography variant="h6" className="section-heading"><FiMail /> Notification Settings</Typography>
        <Divider />
        <FormControlLabel
          control={<Switch color="primary" />}
          label="Receive Email Alerts"
        />
        <FormControlLabel
          control={<Switch color="secondary" />}
          label="Receive SMS Alerts"
        />
      </motion.div> */}

      {/* Save Button */}
      <Box textAlign="center" mt={4}>
        <Button variant="contained" color="success" size="large">
          💾 Save Changes
        </Button>
      </Box>
    </motion.div>
  );
};

export default AdminSettingsPage;
